import React from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { debounce } from 'lodash';
import { TYPEAHEAD_LABEL_KEY } from '../utils/OptionsManager';
import PropTypes from 'prop-types';

const TEXTS = {
    searchPre: I18nUtils.tr('TR_ESPERANDO_BUSQUEDA'),
    search: I18nUtils.tr('TR_BUSCANDO'),
    searchFail: I18nUtils.tr('TR_SIN_RESULTADOS'),
};

export default class FormAutocomplete extends React.Component {

    render() {
        const {
            col,
            loading,
            options,
            disabled,
            placeholder = '',
            label,
            meta: {
                touched,
                error,
            },
            input: {
                value,
                onBlur,
            },
        } = this.props;

        const selected = !!value && Array.isArray(value) ? value : [];
        const formLineClasses = `form-line ${touched && error ? 'focused error' : ''}`;

        return (
            <div className={col}>
                <div className="form-group">
                    <div className={formLineClasses}>
                        <label>{label}</label>
                        <AsyncTypeahead
                            labelKey={TYPEAHEAD_LABEL_KEY}
                            promptText={TEXTS.searchPre}
                            searchText={TEXTS.search}
                            emptyLabel={TEXTS.searchFail}
                            placeholder={placeholder}
                            isLoading={loading || false}
                            options={options} // Debe ser un array con las opciones
                            selected={selected} // Debe ser un array con el resultado
                            onChange={this.handleChange}
                            onSearch={this.debounceSearch}
                            className="input-autocomplete"
                            disabled={disabled}
                            ignoreDiacritics={true}
                            filterBy={() => true}
                            onBlur={() => onBlur(undefined)}
                        />
                    </div>
                    <label className="error">
                        {
                            touched && error ? error : ''
                        }
                    </label>
                </div>
            </div>
        );
    }

    handleChange = (value) => {
        const { input, onSelected } = this.props;
        input.onChange(value);
        onSelected && onSelected(value);
    };

    handleSearch = (query) => {
        this.props.onSearch(query);
    };

    // Ejecuta la búsqueda pasados 1 segundo desde el última vez que se invocó (trailing)
    // Es decir, no se ejecutará la búsqueda hasta que la cadencia de tecleo se mayor a 1 segundo
    debounceSearch = debounce(this.handleSearch, 1000, { leading: false, trailing: true });

}

FormAutocomplete.propTypes = {
    col: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    onSelected: PropTypes.func, // Permite saber en tiempo real el valor seleccionado (útil cuando otros campos dependen de este campo)
};



// WEBPACK FOOTER //
// ./src/app/shared/components/FormAutocomplete.jsx